import { Avatar, Color, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { StyleSheet, View } from 'react-native'
import { User } from 'zens-store'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  detail: {
    marginHorizontal: Spacing.S,
  },
  name: {},
  email: {
    color: Color.metalGrey,
    fontSize: 14,
  },
})

interface Props {
  user: User
}
const UserCell = (props: Props) => {
  const { user } = props
  const { displayName, email } = user

  return (
    <View style={styles.container}>
      <Avatar name={displayName} email={email} />
      <View style={styles.detail}>
        <Text style={styles.name}>{displayName}</Text>
        <Text style={styles.email}>{email}</Text>
      </View>
    </View>
  )
}

export default UserCell
